"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _omit = _interopRequireDefault(require("../utils/omit"));

var _controlLabel = _interopRequireDefault(require("../control-label"));

var _controlWrapper = _interopRequireDefault(require("../control-wrapper"));

var _popover = _interopRequireDefault(require("../popover"));

var _icon = _interopRequireDefault(require("../icon"));

var _getWindow = _interopRequireDefault(require("../utils/get-window"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var propNames = ['id', 'value', 'onChange', 'type', 'label', 'noAuto', 'optional', 'aside', 'validationError', 'errorStyle', 'errorTooltipTheme', 'errorTooltipBackgroundColor', 'themeControlInput', 'themeControlWrapper', 'themeLabel', // Passed when used with the Form component
'initialValue', 'validator'];

var ControlText =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ControlText, _React$Component);

  function ControlText(props) {
    var _this;

    _classCallCheck(this, ControlText);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ControlText).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "inputElement", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "errorElement", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onChange", function (e) {
      return _this.props.onChange(e.target.value, _this.props.id);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setInputElement", function (el) {
      _this.inputElement = el;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setErrorElement", function (el) {
      _this.errorElement = el;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getErrorElement", function () {
      return _this.errorElement;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onErrorClick", function () {
      if (_this.inputElement) _this.inputElement.select();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onFocus", function () {
      _this.setState({
        popoverOpen: true
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onBlur", function () {
      _this.setState({
        popoverOpen: false
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "isActive", function () {
      return (0, _getWindow.default)().document.activeElement === _this.inputElement || (0, _getWindow.default)().document.activeElement === _this.errorElement;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onContainerMouseOver", function () {
      if (_this.isActive()) return;

      _this.setState({
        popoverOpen: true
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onContainerMouseOut", function () {
      if (_this.isActive()) return;

      _this.setState({
        popoverOpen: false
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderLabel", function () {
      var _this$props = _this.props,
          id = _this$props.id,
          label = _this$props.label,
          optional = _this$props.optional,
          aside = _this$props.aside,
          themeLabel = _this$props.themeLabel;
      return _react.default.createElement(_controlLabel.default, {
        text: label,
        id: id,
        aside: aside,
        optional: optional,
        themeLabel: themeLabel
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderPopover", function () {
      var _this$props2 = _this.props,
          validationError = _this$props2.validationError,
          errorTooltipTheme = _this$props2.errorTooltipTheme,
          errorTooltipBackgroundColor = _this$props2.errorTooltipBackgroundColor;
      var popoverProps = {
        getAnchorElement: _this.getErrorElement,
        placement: 'top',
        receiveFocus: false,
        accessibleTitle: 'Validation error'
      };

      if (errorTooltipBackgroundColor) {
        popoverProps.backgroundColor = errorTooltipBackgroundColor;
      }

      if (errorTooltipTheme) {
        popoverProps.themePopover = errorTooltipTheme;
      }

      return _react.default.createElement(_popover.default, popoverProps, validationError);
    });

    _this.state = {
      popoverOpen: false
    };
    return _this;
  }

  _createClass(ControlText, [{
    key: "render",
    value: function render() {
      var extraProps = (0, _omit.default)(this.props, propNames);
      var _this$props3 = this.props,
          id = _this$props3.id,
          value = _this$props3.value,
          label = _this$props3.label,
          type = _this$props3.type,
          optional = _this$props3.optional,
          validationError = _this$props3.validationError,
          errorStyle = _this$props3.errorStyle,
          noAuto = _this$props3.noAuto,
          themeControlInput = _this$props3.themeControlInput,
          themeControlWrapper = _this$props3.themeControlWrapper;
      var popoverOpen = this.state.popoverOpen;
      var inputProps = {
        id: id,
        name: id,
        onChange: this.onChange,
        value: value,
        type: type,
        className: themeControlInput,
        'aria-required': optional ? false : true,
        'data-test': "".concat(id, "-input")
      };

      if (noAuto) {
        inputProps.autoCapitalize = 'none';
        inputProps.autoCorrect = 'off';
        inputProps.spellCheck = false;
      }

      if (validationError) {
        inputProps['aria-invalid'] = true;
      }

      if (validationError && errorStyle === 'inline') {
        inputProps.className = "".concat(themeControlInput, " round-l flex-child flex-child--grow");
        inputProps.style = {
          boxShadow: 'inset 0 0 0 1px #f74e4e'
        };
      }

      var labelElement = label ? this.renderLabel() : null;
      var popover = popoverOpen ? this.renderPopover() : null;

      var control = _react.default.createElement("input", _extends({}, inputProps, extraProps));

      if (errorStyle === 'inline') {
        if (validationError) {
          control = _react.default.createElement("div", {
            onMouseOver: this.onContainerMouseOver,
            onMouseOut: this.onContainerMouseOut,
            "data-test": "control-text-container",
            className: "flex-parent"
          }, _react.default.createElement("input", _extends({
            ref: this.setInputElement,
            onFocus: this.onFocus,
            onBlur: this.onBlur
          }, inputProps, extraProps)), _react.default.createElement("button", {
            type: "button",
            onFocus: this.onFocus,
            onBlur: this.onBlur,
            ref: this.setErrorElement,
            onClick: this.onErrorClick,
            role: "alert",
            "aria-label": validationError,
            className: "flex-child bg-red color-white round-r px6"
          }, _react.default.createElement("span", {
            className: "flex-parent flex-parent--center-cross flex-parent--center-main"
          }, _react.default.createElement(_icon.default, {
            name: "alert",
            themeIcon: "cursor-pointer"
          }))));
        }

        return _react.default.createElement(_controlWrapper.default, {
          themeControlWrapper: themeControlWrapper,
          id: id
        }, labelElement, control, popover);
      }

      return _react.default.createElement(_controlWrapper.default, {
        themeControlWrapper: themeControlWrapper,
        id: id,
        validationError: validationError
      }, labelElement, control);
    }
  }]);

  return ControlText;
}(_react.default.Component);

exports.default = ControlText;

_defineProperty(ControlText, "propTypes", {
  /** Unique id for this control. Required if you want a `label`. */
  id: _propTypes.default.string.isRequired,

  /**
   * Invoked when the control's value changes.
   * Passed two arguments:
   *
   * - `value` the current value of the input passes as a string
   * - The `id` prop.
   */
  onChange: _propTypes.default.func.isRequired,

  /** The control's value. Can be an empty string to indicate no value. */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** Type attribute to override the existing default of 'text' */
  type: _propTypes.default.string,

  /** Label for the control. */
  label: _propTypes.default.string,

  /** Enable/Disable browser enabled autocorrect or spelling suggestions from the element. */
  noAuto: _propTypes.default.bool,

  /** If provided, "(optional)" is appended to the value of the legend element. */
  optional: _propTypes.default.bool,

  /** Additional content inserted alongside the label element. */
  aside: _propTypes.default.node,

  /** If provided, the value of this propery displays as an error message. */
  validationError: _propTypes.default.node,

  /**
   * Sets the style of the error message. There are two options:
   *
   * - `default` the standard presentation control components display an error
   *   message: beneath the input.
   * - `inline` An error indicator is displayed to the right of the element
   *   with the value of `validationError` prop displayed in a tooltip.
   */
  errorStyle: _propTypes.default.oneOf(['default', 'inline']),

  /** Background color of the error tooltip when `errorStyle: "inline"` is set. */
  errorTooltipBackgroundColor: _propTypes.default.string,

  /** Classes to style the error tooltip container. */
  errorTooltipTheme: _propTypes.default.string,

  /** Classes to apply to the input element */
  themeControlInput: _propTypes.default.string,

  /** Classes to apply to the control wrapper */
  themeControlWrapper: _propTypes.default.string,

  /** classes to apply to the label element */
  themeLabel: _propTypes.default.string
});

_defineProperty(ControlText, "defaultProps", {
  value: '',
  type: 'text',
  optional: false,
  noAuto: false,
  errorStyle: 'default',
  themeControlInput: 'input'
});